// Generated by Melange

import * as Buhta_landing__Link from "../../components/html/Link.js";
import * as Buhta_landing__Route from "../../Route.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function DocsSidebar(Props) {
  const language = Buhta_landing__Route.getLanguage(undefined);
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  let homeColor;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    homeColor = "text-black-landing";
  } else {
    switch (currentRoute._2) {
      case /* Home */ 0 :
        homeColor = "text-primary-variant";
        break;
      case /* Kassa */ 1 :
      case /* Post */ 2 :
        homeColor = "text-black-landing";
        break;
    }
  }
  let homeIcon;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    homeIcon = StaticAsset.src("/static/icons/home-black.svg");
  } else {
    switch (currentRoute._2) {
      case /* Home */ 0 :
        homeIcon = StaticAsset.src("/static/icons/home-blue.svg");
        break;
      case /* Kassa */ 1 :
      case /* Post */ 2 :
        homeIcon = StaticAsset.src("/static/icons/home-black.svg");
        break;
    }
  }
  let kassaColor;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    kassaColor = "text-black-landing";
  } else {
    switch (currentRoute._2) {
      case /* Kassa */ 1 :
        kassaColor = "text-primary-variant";
        break;
      case /* Home */ 0 :
      case /* Post */ 2 :
        kassaColor = "text-black-landing";
        break;
    }
  }
  let kassaIcon;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Docs */ 1) {
    kassaIcon = StaticAsset.src("/static/icons/cashier-black.svg");
  } else {
    switch (currentRoute._2) {
      case /* Kassa */ 1 :
        kassaIcon = StaticAsset.src("/static/icons/cashier-blue.svg");
        break;
      case /* Home */ 0 :
      case /* Post */ 2 :
        kassaIcon = StaticAsset.src("/static/icons/cashier-black.svg");
        break;
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                alt: "logo blue",
                src: StaticAsset.src("/static/icons/logo-blue.svg")
              }),
              JsxRuntime.jsx("img", {
                className: "lg:hidden",
                alt: "avatar black",
                src: StaticAsset.src("/static/icons/avatar-black.svg")
              })
            ],
            className: "flex items-center justify-between"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Docs */ 1,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: language,
                  _2: /* Home */ 0
                },
                className: "flex",
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "buhta",
                    src: homeIcon
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Home",
                    className: "paragraph-small-medium " + homeColor + " ml-3"
                  })
                ]
              }),
              JsxRuntime.jsxs(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Docs */ 1,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: language,
                  _2: /* Kassa */ 1
                },
                className: "flex mt-8",
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "buhta",
                    src: kassaIcon
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Касса",
                    className: "paragraph-small-medium " + kassaColor + " ml-3"
                  })
                ]
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "box black",
                    src: StaticAsset.src("/static/icons/box-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Склад и закупки",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "papers black",
                    src: StaticAsset.src("/static/icons/papers-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Налоговая отчетность",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "integration black",
                    src: StaticAsset.src("/static/icons/integration-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Интеграция с банками",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "docs black",
                    src: StaticAsset.src("/static/icons/docs-black-20.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Документооборот",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "employee black",
                    src: StaticAsset.src("/static/icons/employee-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Зарплаты и кадр",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "report black",
                    src: StaticAsset.src("/static/icons/report-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "ЭСФ",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "xreport black",
                    src: StaticAsset.src("/static/icons/xreport-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "ТИС",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-8"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "key black",
                    src: StaticAsset.src("/static/icons/key-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "API",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    alt: "piechart black",
                    src: StaticAsset.src("/static/icons/piechart-black.svg")
                  }),
                  JsxRuntime.jsx("p", {
                    children: "Решения",
                    className: "paragraph-small-medium text-black-landing ml-3"
                  })
                ],
                className: "flex mt-8"
              }),
              JsxRuntime.jsx("p", {
                children: "Товароучетная система",
                className: "paragraph-small text-gray-landing ml-8 mt-2"
              }),
              JsxRuntime.jsx("p", {
                children: "Крупный бизнес",
                className: "paragraph-small text-gray-landing ml-8 mt-1"
              }),
              JsxRuntime.jsx("p", {
                children: "Рестораны",
                className: "paragraph-small text-gray-landing ml-8 mt-1"
              }),
              JsxRuntime.jsx("p", {
                children: "Розничная торговля",
                className: "paragraph-small text-gray-landing ml-8 mt-1"
              }),
              JsxRuntime.jsx("p", {
                children: "Оптовая торговля",
                className: "paragraph-small text-gray-landing ml-8 mt-1"
              }),
              JsxRuntime.jsx("p", {
                children: "Онлайн-магазин",
                className: "paragraph-small text-gray-landing ml-8 mt-1"
              })
            ],
            className: "mt-12.5 hidden lg:block"
          })
        ]
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            alt: "location blue",
            src: StaticAsset.src("/static/icons/location-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Казахстан",
            className: "paragraph-small-medium text-primary-variant ml-3"
          })
        ],
        className: "hidden lg:flex"
      })
    ],
    className: "px-6 pt-4.5 pb-6 border-r border-divider flex flex-col justify-between lg:min-h-screen"
  });
}

const make = DocsSidebar;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
